import { render, staticRenderFns } from "./RouteBreadcrumb.vue?vue&type=template&id=c5ba51cc"
import script from "./RouteBreadcrumb.vue?vue&type=script&lang=js"
export * from "./RouteBreadcrumb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports